import axios from 'axios';

export default {
  // Важно, запрашивать после выбора модели, ибо у нас могут быть разные размеры, которые вытягиваются из опций
  // Размер || Тип окна
  loadOptions({ commit, dispatch }, { id }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/models/${id}/options`).then(
        res => {
          commit('updateOptionsList', res.data);
          resolve(res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  setOptionsListEditOrder({ state, commit }, options = []) {
    const optionsObj = options.reduce(
      (acc, value) => ({
        ...acc,
        [value.name]: value,
      }),
      {},
    );

    const currentOptions = state.optionsListOriginal.map(item => {
      const optionObjItem = optionsObj[item.name];

      if (optionObjItem) {
        return {
          ...item,
          option_default: optionObjItem.option_value,
        };
      }

      return item;
    });

    commit('updateOptionsListData', currentOptions);
  },

  optionsClear({ commit, dispatch, state }) {
    commit('updateOptionsComment', '');
    commit('updateOptionsList', state.optionsListOriginal);
  },
};
